import { T } from "@/locales";

export const columns = [
  {
    title: T("序号"),
    dataIndex: "index",
    key: "index",
    customRender: (value, item, index) => {
      return index + 1;
    },
  },
  {
    title: T("货品名称"),
    dataIndex: "name",
    key: "name",
    sorter: true,
  },
  {
    title: T("货品编号"),
    dataIndex: "number",
    key: "number",
    sorter: true,
  },
  {
    title: T("单位"),
    dataIndex: "unit",
    key: "unit",
  },
  {
    title: T("操作"),
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];
